import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Hero.css";
import { useNavigate } from "react-router-dom";

import ParticlesBackground from "./ParticlesBackground";

import DesignImage from "./images/Software-IT-Services-Transparent-PNG.png";
import SEO from "./images/search-engine-optimization-free-png.webp";
import Cybersecurity from "./images/2476893.webp";

const Hero = ({ isDarkMode }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);
  const [animateCarousel, setAnimateCarousel] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setAnimateCarousel(true);
  }, []);

  const handleNavigation = (link) => {
    navigate(link);
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    beforeChange: (_, newIndex) => {
      setFadeOut(true);
      setCurrentSlide(newIndex);
    },
    afterChange: () => {
      setFadeOut(false);
    },
  };

  const slides = [
    {
      title: "Creative Web & Graphic Design",
      description: "Crafting experiences that captivate and engage your audience.",
      image: DesignImage,
      alt: "Web Design & Graphic Design Services in Nairobi, Kenya, Africa",
      link: "/services/web-design",
    },
    {
      title: "Strategic Marketing & SEO",
      description: "Helping your brand reach the right audience, every time.",
      image: SEO,
      alt: "SEO & Digital Marketing Services in Nairobi, Kenya, Africa",
      link: "/services/marketing",
    },
    {
      title: "Robust Cybersecurity Solutions",
      description: "Protecting your digital assets with industry-leading security.",
      image: Cybersecurity,
      alt: "Cybersecurity Services in Nairobi, Kenya, Africa",
      link: "/services/cyber-security",
    },
  ];

  return (
    <section className={`hero ${isDarkMode ? "dark" : "light"}`}>

      {/* 🌐 PARTICLES (shared component) */}
      <ParticlesBackground isDarkMode={isDarkMode} />

      <Slider
        {...sliderSettings}
        className={`carousel ${animateCarousel ? "animate" : ""}`}
      >
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-content-container ${
              fadeOut ? "fade-out" : ""
            } ${currentSlide === index ? "animate" : ""}`}
          >
            <div className="hero-content">
              <h1 className="hero-title">{slide.title}</h1>
              <p className="hero-description">{slide.description}</p>
              <button
                className="hero-button"
                onClick={() => handleNavigation(slide.link)}
              >
                Get Started
              </button>
            </div>

            <img
              src={slide.image}
              alt={slide.alt}
              className={`hero-image ${
                currentSlide === index ? "animate" : ""
              }`}
            />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Hero;
